import React from "react"
import ReactDOM from "react-dom"
import { Provider } from "react-redux"
import ModernHomepage from "../../components/ModernHomepage"
import store from "../../services/store"
import misago from "../../index"

export default function initializer(context) {
  // Check if we should render the modern homepage
  const currentLink = context.get("CURRENT_LINK")
  const threadsOnIndex = context.get("THREADS_ON_INDEX")
  
  // Only initialize on categories page or when threads are on index
  if (currentLink === "misago:categories" || (threadsOnIndex && window.location.pathname === "/")) {
    const root = document.getElementById("modern-homepage-mount")
    
    if (root) {
      const homepageData = window.modernHomepageData || {}
      
      ReactDOM.render(
        <Provider store={store.getStore()}>
          <ModernHomepage 
            categories={homepageData.categories || []}
            latestThreads={homepageData.latestThreads || []}
            trendingThreads={homepageData.trendingThreads || []}
            stats={homepageData.stats || {}}
            user={context.get("user")}
          />
        </Provider>,
        root
      )
    }
  }
}

misago.addInitializer({
  name: "component:modern-homepage",
  initializer: initializer,
  after: "store",
})